<template>
    <div class="case-detail">
      <!-- 题目 start -->
      <div v-if="testResult=='' && item.type==1">
        <div class="page-title font-s24 c33" style="padding-bottom: 40px;">{{testTitle}}
            <span class="font-s14 c4d pl-30" v-if="login!=true || vip!=true">
                需要在
                  <span v-if="login==false && vip==false">登录</span>
                  <span v-if="login==true && vip==false">会员</span>
                  <span v-if="login==false && vip==true">登录</span>
                的情况下，才能做题
            </span>
        </div>
        <el-form :model="dynamicValidateForm" ref="dynamicValidateForm" label-width="0px" class="demo-dynamic">
             <el-row  v-for="(item, index) in dynamicValidateForm.subject" :key="index">
                {{index+1}}、{{item.title}}
                <el-form-item
                    :prop="'subject.' + index + '.value'"
                    :rules="{required: true, message: '请选择', trigger: 'blur'}"
                >
                <el-radio-group v-model="item.value" @change="radioChange">
                    <el-radio v-for="(val,valIndex) in item.list" :key="valIndex" :label="val.rid">{{val.title}}</el-radio>
                </el-radio-group>
                </el-form-item>
            </el-row>
            <!--  -->
            <el-form-item>
                    <el-button type="primary" plain  @click="submitForm('dynamicValidateForm')" :disabled="disabledBtn">提交结果</el-button>
            </el-form-item>
        </el-form>
      </div>
      <!-- 题目 end -->
      <!-- 结果  start -->
      <div class="case-detail"  v-if="testResult!=''">
          <div class="border-title  font-s24 c33">{{testResult.title}}</div>
          <div class="font-s18 c33 result">您的测试综合评分为{{testResult.score}}，{{testResult.tips}}</div>
      </div>
      <!-- 结果  end -->
      <!-- 新闻 -->
      <div v-if="testResult=='' && item.type==2">
          <div class="page-title font-s24 c33" style="padding-bottom: 40px;">{{testTitle}}</div>
          <div v-html="newContent"></div>
      </div>
    </div>
</template>

<script>
import { HealthyList } from "../../api/api";
import { GetHealthyScore } from "../../api/api";
import { QuestionNewInfo } from "../../api/api";
export default {
  data() {
    return {
      //         id:id,    type,//类型    1量表 2新闻
      item:
        this.$route.query.item == undefined
          ? ""
          : JSON.parse(this.$route.query.item),
      dynamicValidateForm: {
        subject: []
      },
      testResult: "", //结果
      testTitle: "正在加载...", //量表名称
      disabledBtn: false,
      newContent: "", //新闻内容
      login: "", //登录状态
      vip: "" //会员状态
    };
  },
  created() {
    if (this.item.type == 1) {
      //量表
      this.getList();
    } else {
      //新闻
      this.getQuestionNewInfo();
    }
  },
  methods: {
    getList() {
      //量表
      var db = {
        id: this.item.id
      };
      this.$axios.post(HealthyList, db).then(
        res => {
          if (res.data.code == 1) {
            this.dynamicValidateForm.subject = res.data.data.list;
            this.testTitle = res.data.data.title;
            this.login = res.data.data.is_login;
            this.vip = res.data.data.is_vip;
          } else {
            this.dynamicValidateForm.subject = [];
          }
        },
        err => {
          this.dynamicValidateForm.subject = [];
        }
      );
    },
    getQuestionNewInfo() {
      //新闻
      var db = {
        id: this.item.id
      };
      this.$axios.post(QuestionNewInfo, db).then(
        res => {
          if (res.data.code == 1) {
            this.newContent = res.data.data.content;
            this.testTitle = res.data.data.title;
          } else {
            this.newContent = "";
          }
        },
        err => {
          this.newContent = "";
        }
      );
    },
    submitForm(formName) {
      if (this.login != true && this.vip != true) {
        this.radioChange();
      } else {
        this.$refs[formName].validate(valid => {
          if (valid) {
            var selId = [];
                for (var i = 0; i < this.dynamicValidateForm.subject.length; i++) {
                    selId.push(this.dynamicValidateForm.subject[i].value);
                }
            var db = {
              id: this.id, //方案id
              rids: selId.join(",") //选择选项的id，用，号相隔
            };
            this.$axios.post(GetHealthyScore, db).then(
              res => {
                this.disabledBtn = true;
                if (res.data.code == 1) {
                  this.testResult = res.data.data;
                  this.disabledBtn = false;
                } else {
                  this.$message.error(res.data.msg);
                  this.disabledBtn = false;
                }
              },
              err => {
                this.$message.error(err.data.msg);
                this.disabledBtn = false;
              }
            );
          } else {
            console.log("error submit!!");
            return false;
          }
        });
      }
    },
    radioChange() {
      if (this.login == false) {
        var item = {
          from: "healthCareDetailResult", //从哪个页面转入
          id: this.item.id,
          type: this.item.type
        };
        this.$router.push({
          name: "userCenter",
          query: { item: JSON.stringify(item) }
        });
      } else if (this.vip == false) {
        var item = {
          from: "healthCareDetailResult", //从哪个页面转入
          id: this.item.id,
          type: this.item.type
        };
        this.$router.push({
          name: "userPrice",
          query: { item: JSON.stringify(item) }
        });
      }
    }
  }
};
</script>

<style lang="scss">
.case-detail {
  .case-detail {
    .result {
      padding-top: 30px;
      text-align: justify;
    }
  }
}
</style>
